import { render, staticRenderFns } from "./TablaPaises.vue?vue&type=template&id=3f6e1b85"
import script from "./TablaPaises.vue?vue&type=script&lang=js"
export * from "./TablaPaises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports